import React from "react";
import ModalFormComanda from "./ModalFormComanda";

const ModalComanda = ({ show, handleClose, comanda }) => {
  return (
    <ModalFormComanda show={show} handleClose={handleClose} comanda={comanda} />
  );
};

export default ModalComanda;
